import VNode from '../utils/vnode';
import XNode from '../utils/xnode';
import headerVnode from './header';
import bodyVnode from './body';
import footerVnode from './footer';
import ppXml from '../docs/privacy-protocol'; // 通过在线格式转换或work转xml生成

export default new VNode({
  type: 'div',
  attrs: {
    class: 'login'
  },
  styles: {
    width: '70vw',
    margin: '5vh auto',
    boxShadow: 'rgb(115, 115, 115) 0px 0px 5px',
    borderRadius: '6px',
    padding: '10px',
  },
  children: [
    headerVnode,
    bodyVnode,
    footerVnode,
    new XNode({ xml: ppXml })
  ],
  watch: {
    account(val) {
      console.log(val, this)
    }
  }
});